// The query Lambdas deliberately return generic 500 bodies, so an over-budget
// query is only recognizable by how the gateway reports it: 504 when API
// Gateway's 29 s cap fires first, 502 when the Lambda is killed at its own
// timeout or its response is too large to return, 408/413 from other hops.
const OVERLOAD_STATUS_CODES: ReadonlyArray<number> = [408, 413, 502, 504]
const OVERLOAD_MESSAGE_PATTERN = /timed?\s*out|timeout|payload size|too (?:large|much data)/i

export const QUERY_OVERLOAD_MESSAGE =
  'This search took too long or returned too much data. Please try a smaller date range or more specific filters.'
export const GENERIC_QUERY_ERROR_MESSAGE = 'An error has occurred'

const errorStatusCode = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') return undefined
  // ApiRequestError carries statusCode directly; Amplify's RestApiError nests
  // it under response.
  const candidate = error as { statusCode?: unknown; response?: { statusCode?: unknown } }
  const statusCode = candidate.statusCode ?? candidate.response?.statusCode
  return typeof statusCode === 'number' ? statusCode : undefined
}

export const isQueryOverloadError = (error: unknown): boolean => {
  const statusCode = errorStatusCode(error)
  if (statusCode !== undefined) return OVERLOAD_STATUS_CODES.includes(statusCode)
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return OVERLOAD_MESSAGE_PATTERN.test(message)
}

export const queryErrorAlertMessage = (error: unknown): string =>
  isQueryOverloadError(error) ? QUERY_OVERLOAD_MESSAGE : GENERIC_QUERY_ERROR_MESSAGE
